import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';

export class MaintenanceWindowGridBaseDataProvider extends BaseWebComponentDataProvider {
  /**
   * Remove records
   * @param params
   */
  async removeRecords(params: any): Promise<{ success: boolean }> {
    throw new Error('Not implemented');
  }
}
